<smt-custom-list *ngIf="!loading" [viewerConfigId]="viewerConfigId" [customImageResolver]="customImageResolver"></smt-custom-list>